import axios from "axios";
import { UrlFilterHelper } from "_helpers/UrlFilterHelper";

const API_URL = process.env.REACT_APP_API_URL;
const DASHBOARD_USER = API_URL + "/dashboardUser";
const DASHBOARD_STAFF = API_URL + "/dashboardStaff";

const DASHBOARD_GET_BIDS = DASHBOARD_STAFF + "/GetBids"
const GET_APPROVED_PRODUCTS_ACTION_URL = "/GetApprovedProducts";
const GET_VSTS_SUBSCRIPTIONS_ACTION_URL = "/GetVstsSubscriptions";
const GET_VSTT_SUBSCRIPTIONS_ACTION_URL = "/GetVsttSubscriptions";
const UPSERT_VSTS_SUBSCRIPTIONS_ALERT_URL = "/UpsertVstsSubscriptionAlert";
const UPSERT_APPROVED_PRODUCT_ALERT_URL = "/UpsertApprovedProductAlert";
const GET_CERTIFICATION_PACKAGES_ACTION_URL = "/GetActiveCertificationPackages";


function DashboardApi(baseUrl) {

    function getApprovedProducts(bid, skipCount, sortBy, desc) {
        let url = UrlFilterHelper.GetFilterdUrl(baseUrl + GET_APPROVED_PRODUCTS_ACTION_URL, skipCount, null, sortBy, desc, null);
        url += "&bid=" + bid;
        return axios.get(url);
    }

    function getVstsSubscriptions(bid, skipCount, sortBy, desc) {
        let url = UrlFilterHelper.GetFilterdUrl(baseUrl + GET_VSTS_SUBSCRIPTIONS_ACTION_URL, skipCount, null, sortBy, desc, null);
        url += "&bid=" + bid;
        return axios.get(url);
    }

    function getVsttSubscriptions(bid) {
        let url = baseUrl + GET_VSTT_SUBSCRIPTIONS_ACTION_URL;
        url += "?bid=" + bid
        return axios.get(url);
    }

    function upsertVstsSubscriptionAlert(data, bid, skipCount, sortBy, desc) {
        let url = UrlFilterHelper.GetFilterdUrl(baseUrl + UPSERT_VSTS_SUBSCRIPTIONS_ALERT_URL, skipCount, null, sortBy, desc, null);
        url += "&bid=" + bid;
        
        return axios.post(url, data);
    }

    
    function upsertApprovedProductAlert(data, bid, skipCount, sortBy, desc) {
        let url = UrlFilterHelper.GetFilterdUrl(baseUrl + UPSERT_APPROVED_PRODUCT_ALERT_URL, skipCount, null, sortBy, desc, null);
        url += "&bid=" + bid;
        
        return axios.post(url, data);
    }

    function getBids() {
        return axios.get(DASHBOARD_GET_BIDS);
    }

    function getActiveCertificationPackages(bid, sortBy, desc) {
        let url = UrlFilterHelper.GetFilterdUrl(baseUrl + GET_CERTIFICATION_PACKAGES_ACTION_URL, 0, null, sortBy, desc, null);  
        url += "&bid=" + bid;

        return axios.get(url);
    }

    let apis = {
        "getApprovedProducts": getApprovedProducts,
        "getVstsSubscriptions": getVstsSubscriptions,
        "getVsttSubscriptions": getVsttSubscriptions,
        "upsertVstsSubscriptionAlert": upsertVstsSubscriptionAlert,
        "upsertApprovedProductAlert": upsertApprovedProductAlert,
        "getActiveCertificationPackages": getActiveCertificationPackages,
        "getBids": baseUrl === DASHBOARD_STAFF ? getBids : undefined
    }
    return apis
}


export const DashboardUserApi = DashboardApi(DASHBOARD_USER);
export const DashboardStaffApi = DashboardApi(DASHBOARD_STAFF);
